<p-toast></p-toast>

<app-page-shell>

    <app-page-hero
        eyebrow="Fleet Mobilization"
        title="Audit History"
        subtitle="Backend-backed lifecycle timeline for mobilization records.">
        <div nav>
            <p-button label="Overview" icon="pi pi-chart-line" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization"></p-button>
            <p-button label="Entries" icon="pi pi-list" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization/entries"></p-button>
            <p-button label="Approvals" icon="pi pi-check-square" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization/change-requests"></p-button>
            <p-button label="History" icon="pi pi-history" routerLink="/fleet/mobilization/history"></p-button>
        </div>
        <div actions>
            <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" [loading]="isLoading" (onClick)="loadEvents()"></p-button>
        </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-data-panel title="Audit Log" subtitle="Every create, update, and lifecycle action writes an event." [resultText]="events.length + ' events'">
        <p-table [value]="events" [loading]="isLoading" styleClass="p-datatable-sm" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Time</th>
                    <th>Mobilization</th>
                    <th>Action</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Actor</th>
                    <th>Comment</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-event>
                <tr>
                    <td>{{ dateTimeLabel(event.eventTime) }}</td>
                    <td class="font-semibold">MOB-{{ event.mobilizationId }}</td>
                    <td><p-tag [value]="actionLabel(event.actionCode)" [severity]="actionSeverity(event.actionCode)"></p-tag></td>
                    <td><p-tag *ngIf="event.fromStatus" [value]="event.fromStatus" [severity]="statusSeverity(event.fromStatus)"></p-tag></td>
                    <td><p-tag *ngIf="event.toStatus" [value]="event.toStatus" [severity]="statusSeverity(event.toStatus)"></p-tag></td>
                    <td>{{ event.actorName || 'System' }}</td>
                    <td>{{ event.comment || '-' }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7" class="empty-cell">No audit events found.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
